import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { faCaretUp, faCaretDown, faAnglesDown, faAnglesLeft, faCaretLeft, faSquarePlus, faSquareMinus } from '@fortawesome/free-solid-svg-icons'

export default class Icons {
    initialize(){
        library.add(fas, faCaretUp, faCaretDown, faAnglesDown, faAnglesLeft, faCaretLeft);

    }
}